{
  "new-team": "Create team",
  "add-teams": "Create team",
  "create-team-header": "Create team",
  "add-team-header": "Create team",
  "update-team-header": "Edit team",
  "move-team-header": "Move team",
  "add-members-header": "Add members",
  "move-team-disclaimer": "Please select where you would like to move this team. Please note that any associated teams will be moved with its parent.",
  "delete-team-header": "Delete team",
  "delete-team-disclaimer": "Once deleted, this team will be permanently deleted. Are you sure you want to do this?",
  "remove-member-header": "Remove member",
  "remove-team-user-disclaimer": "Once removed, this member will no longer be part of this team.",
  "teams-name-label": "Please enter team name:",
  "teams-name-placeholder": "Team name",
  "teams-parent-placeholder": "Select parent team",
  "no-parent": "No parent team",
  "parent": "Parent team: {{name}}",
  "sub-team-context": "Manage Team A team associated teams. Create, move, or rearrange teams.",
  "team-user-context": "Manage {{name}} members. Set roles, add and remove members.",
  "save": "Save",
  "add": "Add",
  "add-members": "Add members",
  "create": "Create",
  "move": "Move",
  "delete": "Delete",
  "cancel": "Cancel",
  "users": "Users",
  "members": "Members",
  "sub-teams": "Associated Team",
  "sub-teams_plural": "Associated Teams",
  "associated-teams": "Associated Teams",
  "team-not-found": "Team not found",
  "team-user-not-found": "Member not found",
  "name": "Name",
  "email": "Email",
  "role": "Role",
  "status": "Status",
  "managers": "Managers",
  "find-teams": "Find team",
  "find-member": "Find member",
  "banner-title": "Set up your organization with Teams",
  "banner-subtitle": "Collegial platform Teams is where set up your working teams with their rights. Here’s what you can do.",
  "banner-list-teams": "List teams",
  "banner-list-teams-subtitle": "Find all teams, view reports and analytics for the user on their teams",
  "banner-create-new-teams": "Create new teams",
  "banner-create-new-teams-subtitle": "Create as many teams as you would like in your hierarchy",
  "banner-manage-teams": "Manage teams",
  "banner-manage-teams-subtitle": "Organize your users into teams with team managers",
  "role-member": "Member",
  "role-member-description": "Can access all the content available to the team",
  "role-manager": "Manager",
  "role-manager-description": "Can also edit team members and view their analytics",
  "change-role-header": "Change role",
  "select-user-role": "{{user}} role",
  "tooltip-information-label" : "INFORMATION",
  "tooltip-parent-team-description": "A parent team is a team that has other teams underneath it. The teams under the parent team are called associated teams."
}
